<template>
  <div class="wrapper">
    <div class="header">Voice+ Releases</div>
    <div class="releasesWrapper" v-if="!loading">
      <b-loading v-model="loading" is-full-page :can-cancel="false"></b-loading>
      <div class="release box" v-for="release in this.releases" :key="release.id">
        <div class="releaseTitle subtitle">Release {{ release.name }}</div>
        <div class="releaseButton"><b-button type="is-primary" @click="$router.push('/voiceplus/releases/' + release.id)">View Release Notes</b-button></div>
      </div>
    </div>
    <b-loading v-model="loading" is-full-page :can-cancel="false"></b-loading>
  </div>
</template>

<style scoped>
.link {
  font-weight: bold;
}
.wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 99fr;
  width: 80%;
  margin: 10px auto;
}
.releasesWrapper {
  display: grid;
  grid-template-columns: 1fr;
  height: 500px;
}
.release:hover {
  background-color: #efefef;
}
.release {
  display: grid;
  grid-template-columns: 8fr 1fr;
  grid-template-rows: 1fr;
}
.circle {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  box-shadow: 1px 1px 2px 0px black;
}
.red {
  background-color: rgb(255, 55, 55);
}
.blue {
  background-color: rgb(80, 80, 255);
}
.green {
  background-color: rgb(0, 161, 0);
}
.taskWrapper {
  display: grid;
  grid-template-columns: 1fr 5fr;
}
</style>

<script>
const axios = require("axios");
export default {
  components: {},
  data: function () {
    return {
      apiUrl: "https://api.jeak.co.uk",
      releases: [],
      loading: true,
    };
  },
  methods: {
    GetReleases: async function () {
      this.loading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios.get(this.apiUrl + `/releases`, config).then((response) => {
        this.releases = response.data.reverse();
        this.loading = false;
      });
    },
    OpenRelease: async function (releaseId) {},
    CloseRelease: async function () {
      this.viewingReleaseNotes = false;
      this.release = {};
    },
  },
  mounted() {
    this.GetReleases();
  },
};
</script>
